<template>
  <v-text-field
    :label="item.label"
    v-model="giacenza"
    :rules="rulesValidation"
    :maxlength="item.maxlength ? item.maxlength: 1000"
    :counter="item.maxlength ? item.maxlength : false"
    :disabled="!updateTrigger || disabled || item.readonly"
    :hint="giacenzaTotale"
    :persistent-hint="magazziniMultipli"
    v-if="showItem"
    @change=onChange>
  </v-text-field>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  
  export default {
    name: 'testo',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: { type: Number, default: 1 }
    },
    data: (vm) => ({
      giacenza: 0
    }),
    mounted() {
      this.giacenza = this.calcolaGiacenza
    },
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return  _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      magazziniMultipli() {
        return this.$store.getters['magazzini/magazziniMultipli']
      },
      magazzinoSelezionato() {
        return this.$store.getters['magazzini/codiceMagazzino']
      },      
      calcolaGiacenza() {
        const giacenza = this.item.value || 0
        if (!this.magazziniMultipli) {
          return giacenza
        } else {
          const giacenzaParziale = _.get(this.appoggio, 'magazzino.giacenzaParziale', null)
          if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
            const gg = giacenzaParziale[this.magazzinoSelezionato] || {}
            return gg.giacenza || 0
          } else {
            return giacenza 
          }
        }
      },
      giacenzaTotale() {
        return `Giacenza totale: ${this.item.value || 0}`
      }      
    },
    methods: {
      onChange(value) {
        // this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value })
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.giacenza })
      }
    }
  }
</script>